module.exports = require("./lib/_stream_passthrough.js")



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/passthrough.js
// module id = 1050
// module chunks = 0